import $ from 'jquery';
import './Pagination';

$('.salespartners').each(function () {
    new Pagination($(this), '.salespartners__country--show', 3)
    filterSalesPartners($(this));
})

$('.salespartners__filter-reset').on('click', function (e) {
    e.preventDefault();
    var $wrap = $(this).closest('.salespartners');
    $wrap.find('.salespartners__filter-select--region, .salespartners__filter-select--country').val('').trigger('change');
    var $pageFilter = $wrap.find('.salespartners__filter-select--page');
    $pageFilter.val($pageFilter.find('option:first-child').attr('value')).trigger('change');
})

$('.salespartners__letter-filter-item').on('click', function (e) {
    e.preventDefault();
    $(this).siblings().removeClass('salespartners__letter-filter-item--active');
    $(this).toggleClass('salespartners__letter-filter-item--active');
    filterSalesPartners($(this).closest('.salespartners'))
})

$('.salespartners__filter-select--region').on('change', function () {
    var $countrySelect = $(this).closest('.salespartners__filter').find('.salespartners__filter-select--country');
    if ($(this).val() === '') {
        $countrySelect.find('option').removeAttr('disabled');
    } else {
        $countrySelect.val('');
        $countrySelect.find('option:not(:first-child)').attr('disabled', 'disabled');
        $countrySelect.find('option[data-region="' + $(this).val() + '"]').removeAttr('disabled');
    }
    $countrySelect.trigger('change');
    filterSalesPartners($(this).closest('.salespartners'));
})

$('.salespartners__filter-select--country').on('change', function () {
    filterSalesPartners($(this).closest('.salespartners'));
})

function filterSalesPartners($wrap) {
    var region = parseInt($wrap.find('.salespartners__filter-select--region').val());
    var country = parseInt($wrap.find('.salespartners__filter-select--country').val());
    var $items = $wrap.find('.salespartners__country');

    $items.addClass('salespartners__country--show');

    $items.each(function () {
        if (!isNaN(region) && $(this).data('region') !== region) {
            $(this).removeClass('salespartners__country--show')
        }

        if (!isNaN(country) && $(this).data('id') !== country) {
            $(this).removeClass('salespartners__country--show')
        }
    })

    var availableLetters = [];
    $wrap.find('.salespartners__country--show').each(function () {
        availableLetters.push($(this).data('country-name').charAt(0).toUpperCase());
    })
    var $letterFilterItems = $('.salespartners__letter-filter-item');
    $letterFilterItems.addClass('salespartners__letter-filter-item--disabled');
    $letterFilterItems.each(function () {
        if ($.inArray($(this).data('value'), availableLetters) !== -1) {
            $(this).removeClass('salespartners__letter-filter-item--disabled');
        }
    })

    var $filters = $wrap.find('.salespartners__letter-filter').find('.salespartners__letter-filter-item--active:not(.salespartners__letter-filter-item--disabled)');
    var filterArray = [];
    $filters.each(function () {
        filterArray.push($(this).data('value').toUpperCase());
    })

    $items = $wrap.find('.salespartners__country--show');
    if (filterArray.length > 0) {
        $items.each(function () {
            if ($.inArray($(this).data('country-name').charAt(0).toUpperCase(), filterArray) === -1) {
                $(this).removeClass('salespartners__country--show')
            }
        })
    }

    $wrap.find('.salespartners__count').text($wrap.find('.salespartners__country--show .salespartners__partner').length);
    $wrap.trigger('paginationUpdate');
}
